module.exports = __webpack_public_path__ + "img/s2logo.5c41c279.png";